import { render, staticRenderFns } from "./VocalService.vue?vue&type=template&id=066502d9&"
import script from "./VocalService.vue?vue&type=script&lang=js&"
export * from "./VocalService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports